import React, { useState } from "react";
import { Input as InputDiv, Form } from "./InputStyles";
import { drone } from "../../utils/Scaledrone";

const Input = ({ member }) => {
  const [text, setText] = useState("");

  const onChange = (e) => {
    setText(e.target.value);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (text) {
      drone.publish({
        room: "observable-room",
        message: text,
        member,
      });
    }
    setText("");
  };

  return (
    <InputDiv>
      <Form onSubmit={onSubmit}>
        <input
          onChange={onChange}
          value={text}
          type="text"
          placeholder="Enter your message and press ENTER"
          autoFocus={true}
        />
        <button>Send</button>
      </Form>
    </InputDiv>
  );
};

export default Input;
